import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, SpinButton, Stack, TextField, Toggle} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import NetGrossPicker from "../../Components/NetGrossPicker";

function AddAdditionalFee(props) {
    const [user] = useContext(AuthContext);
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [name, setName] = useState('');
    const [recurring, setRecurring] = useState(true);

    const _submit = (e) => {
        e.preventDefault();
        const data = {net_price: net, vat: vat, gross_price: gross, name: name, transactionId: props.add, recurring: recurring ? 'M' : null};
        fetch(`/api/transaction/${props.add}/fee`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        if (props.add) {
            setGross(0);
            setNet(0);
            setName('');
        }
    }, [props.add])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddAdditionalFee'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    var optionalProps = {};
    if (recurring) optionalProps.defaultChecked = true;

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Opłatę"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddAdditionalFee'>
                <TextField label="Nazwa" value={name} onChange={(e) => setName(e.target.value || '')}/>
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <Toggle label="Cykliczna" {...optionalProps} onText="Tak" offText="Nie"
                        onChange={(e, checked) => setRecurring(checked)}/>
            </form>
        </Panel>
    )
}

export default AddAdditionalFee;